/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable max-len */
/* eslint-disable no-trailing-spaces */
import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { Helmet } from 'react-helmet';
import { CHINA_TITLE, CHINA_DESCRIPTION } from '../../Utils/Constants/SEO';
import ToursResultFunc from '../ToursResult/ToursResultFunc';
import { CHINA_NAME } from '../../Utils/Constants/GlobalConstants';
import { getCountry } from '../../Utils/CommonUtils';

class China extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  getText = () => (
    <div>
      <div className="content_block">
        <h1 className="text_h1">
          Туры в Китай из Минска: Райский отдых с удобным онлайн-бронированием
          на tourhunter.by!
        </h1>
        <p className="text_p">
          Мечтаете о белоснежных пляжах, лазурном Южно-Китайском море и тропиках
          круглый год? Остров Хайнань (Санья) – ваш идеальный выбор! И теперь
          купить тур на Хайнань из Минска стало проще, чем когда-либо, благодаря
          прямым чартерным перелетам.
        </p>
      </div>
      <div className="content_block">
        <h2 className="text_h2">Почему Хайнань – идеальное направление?</h2>
        <p className="text_p">
          "Восточные Гавайи": Уникальная природа, теплый климат 365 дней в году,
          чистейшие пляжи и лагуны с прозрачной водой.
        </p>
        <p className="text_p">
          Роскошные отели: От бутиковых вилл до фешенебельных 5* комплексов с
          сервисом мирового уровня (включая известные SPA-центры).
        </p>
        <p className="text_p">
          Экзотика и комфорт: Знакомство с китайской культурой, невероятная
          кухня, термальные источники, парки и заповедники – и все это с высоким
          уровнем сервиса.
        </p>
        <p className="text_p">
          Безвизовый режим: Для граждан РБ при въезде на срок до 30 дней – нужен
          только паспорт!
        </p>
      </div>
      <div className="content_block">
        <p className="text_p">
          Лучшие цены и акции: мы агрегируем предложения напрямую от
          туроператоров, что позволяет вам купить тур на Хайнань из Минска по
          выгодной стоимости. Следите за горящими турами и специальными
          предложениями!
        </p>
        <p className="text_p">
          Безопасная онлайн-оплата: оплатите выбранный тур на Хайнань удобным
          вам способом прямо на сайте через защищенное соединение. Никаких
          рисков, только официальные договоры.
        </p>
        <p className="text_p">
          Экономия времени и сил: Забудьте о поездках по офисам! Весь процесс:
          от поиска идеального варианта до получения документов – легко и быстро
          онлайн на tourhunter.by.
        </p>
      </div>
    </div>
  );

  render() {
    const text = this.getText();
    return (
      <div className="content">
        <Helmet>
          <title>{CHINA_TITLE}</title>
          <meta name="description" content={CHINA_DESCRIPTION} />

          <meta property="og:site_name" content="TourHunter.by" />
          <meta property="og:type" content="website" />
          <meta property="og:url" content="https://tourhunter.by/china/" />
          <meta property="og:title" content={CHINA_TITLE} />
          <meta property="og:description" content={CHINA_DESCRIPTION} />

          <link rel="canonical" href="https://tourhunter.by/china/" />
        </Helmet>
        <ToursResultFunc countryFilter={getCountry(CHINA_NAME)} text={text} />
      </div>
    );
  }
}

export default China;
